export default __webpack_public_path__ + "static/3-mobile-fed2608b715325c6130efe07d5c5832c.webp";